export const columns = [
  {
    title: "Colas",
    dataIndex: "queue_name",
    ellipsis: true,
    width: 300,
    slots: { customRender: "queue_name" },
  },
  {
    title: "Total de llamadas",
    dataIndex: "total_interactions",
    slots: { customRender: "total_calls" },
    width: 180,
  },
  {
    title: "N° NS",
    dataIndex: "sum_service_level",
    // slots: { customRender: "sum_service_level" },
    width: 100,
    tooltip: {
      title: "Número de nivel de servicio.",
      description:
        "Indica cuántas llamadas atiende el agente dentro del nivel de servicio de la cola.",
    },
  },
  {
    title: "NS %",
    dataIndex: "mean_service_level",
    width: 100,
    slots: { customRender: "percent" },
    tooltip: {
      title: "Porcentaje de nivel de servicio.",
      description:
        "Indica el porcentaje de llamadas atendidas por el agente dentro del nivel de servicio de la cola.",
    },
  },
  {
    title: "N° atendidas",
    dataIndex: "total_answered_calls",
    // slots: { customRender: "total_answered_calls" },
    width: 140,
    tooltip: {
      title: "Número de llamadas atendidas.",
      description: "Indica el total de llamadas que fueron atendidas en la cola.",
    },
  },
  {
    title: "% Atendidas",
    dataIndex: "mean_answered_level",
    width: 140,
    slots: { customRender: "percent" },
    tooltip: {
      title: "Porcentaje de llamadas atendidas.",
      description:
        "Indica el porcentaje de llamadas atendidas respecto al total de llamadas en la cola.",
    },
  },
  {
    title: "N° abandonadas",
    dataIndex: "total_dropped_calls",
    // slots: { customRender: "total_dropped_calls" },
    width: 160,
    tooltip: {
      title: "Número de llamadas abandonadas.",
      description: "Indica el total de llamadas que no fueron atendidas en la cola.",
    },
  },
  {
    title: "% Abandonadas",
    dataIndex: "mean_dropped_level",
    width: 160,
    slots: { customRender: "percent" },
    tooltip: {
      title: "Porcentaje de llamadas abandonadas.",
      description:
        "Indica el porcentaje de llamadas abandonadas respecto al total de llamadas en la cola.",
    },
  },
  {
    title: "TP espera",
    dataIndex: "mean_time_waiting",
    slots: { customRender: "time" },
    width: 140,
    tooltip: {
      title: "Tiempo promedio de espera.",
      description:
        "Es el promedio del tiempo que una llamada permanece en la cola hasta ser asignada, o finalizada en llamadas abandonadas.",
    },
  },
  {
    title: "N° en espera",
    dataIndex: "total_calls_waiting",
    width: 140,
    tooltip: {
      title: "Número de llamadas en espera.",
      description:
        "Indica el total de llamadas que se encuentran en cola hasta este momento.",
    },
  },
  {
    title: "TP hablando",
    dataIndex: "mean_time_speaking",
    slots: { customRender: "time" },
    width: 140,
    tooltip: {
      title: "Tiempo promedio de llamada.",
      description:
        "Es el promedio del tiempo que dura la llamada, incluyendo el tiempo de timbrado.",
    },
  },
  {
    title: "TP ACW",
    dataIndex: "mean_time_acw",
    slots: { customRender: "time" },
    width: 140,
    tooltip: {
      title: "Tiempo promedio de ACW.",
      description:
        "Es el promedio del tiempo de ACW del total de llamadas en la cola.",
    },
  },
  {
    title: "Acciones",
    fixed: "right",
    width: 120,
    slots: { customRender: "actions" },
  },
];

